module.exports = __webpack_public_path__ + "static/media/active-right-shield.6a7ec87d.svg";